import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, GithubAuthProvider } from 'firebase/auth';

// Helper function to get environment variable from secrets or process.env
const getEnvVar = (varName: string): string | undefined => {
  // First try to get from window.REACT_APP_SECRETS (injected by server)
  if (typeof window !== 'undefined' && (window as any).REACT_APP_SECRETS?.[varName]) {
    return (window as any).REACT_APP_SECRETS[varName];
  }

  // Fallback to process.env
  return process.env[varName];
};

// Get Firebase config from environment variables
const firebaseConfig = {
  apiKey: getEnvVar('REACT_APP_FIREBASE_API_KEY'),
  authDomain: getEnvVar('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  projectId: getEnvVar('REACT_APP_FIREBASE_PROJECT_ID'),
  storageBucket: getEnvVar('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: getEnvVar('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  appId: getEnvVar('REACT_APP_FIREBASE_APP_ID')
};

// Map field names to environment variable names for error messages
const envVarMap = {
  apiKey: 'REACT_APP_FIREBASE_API_KEY',
  authDomain: 'REACT_APP_FIREBASE_AUTH_DOMAIN',
  projectId: 'REACT_APP_FIREBASE_PROJECT_ID',
  storageBucket: 'REACT_APP_FIREBASE_STORAGE_BUCKET',
  messagingSenderId: 'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  appId: 'REACT_APP_FIREBASE_APP_ID'
};

// Validate required Firebase config
const requiredFields: (keyof typeof firebaseConfig)[] = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'messagingSenderId', 'appId'];
const missingFields = requiredFields.filter(field => !firebaseConfig[field]);

if (missingFields.length > 0) {
  console.error('Firebase configuration is incomplete. Missing fields:', missingFields);
  console.error('Please set the following environment variables in your Render Dashboard:');
  missingFields.forEach(field => {
    console.error(`  - ${envVarMap[field]}`);
  });
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Firebase initialization logging removed for clean console output

// Auth providers
export const googleProvider = new GoogleAuthProvider();
export const githubProvider = new GithubAuthProvider();

// Configure providers for consistent behavior across devices
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;
